import moment from "moment-timezone";
import { Module } from "vuex";
import {
  SET_APP_LOCALE,
  SET_APP_BACKGROUND_COLOR,
  SET_TOP_BAR_TEXT,
  SET_TOP_BAR_VISIBILITY,
  SET_BOTTOM_NAV_BAR_VISIBILITY,
} from "../action-types";
import { SUPPORTED_LOCALES, COMPONENT_VISIBILITY } from "../../types";
import { APP_VERSION } from "../../utils/constants";
import i18n from "../../i18n";

class State {
  version: string;

  backgroundColor: null | string;

  topBarText: string;

  topBarVisibility: keyof typeof COMPONENT_VISIBILITY;

  bottomNavBarVisibility: keyof typeof COMPONENT_VISIBILITY;

  fullscreenLoaderText: string;
}

const apphModule: Module<State, any> = {
  namespaced: true,

  state: {
    version: APP_VERSION,
    backgroundColor: "",
    topBarText: i18n.t("app.name") as string,
    topBarVisibility: COMPONENT_VISIBILITY.visible,
    bottomNavBarVisibility: COMPONENT_VISIBILITY.visible,
    fullscreenLoaderText: "",
  },

  getters: {
    version: (theState: State) => theState.version,
    backgroundColor: (theState: State) => theState.backgroundColor,
    locale: () => i18n.locale,
    topBarText: (theState: State) => theState.topBarText,
    topBarVisibility: (theState: State) => theState.topBarVisibility,
    bottomNavBarVisibility: (theState: State) => theState.bottomNavBarVisibility,
    fullscreenLoaderText: (theState: State) => theState.fullscreenLoaderText,
  },

  mutations: {
    [SET_APP_BACKGROUND_COLOR](theState: State, backgroundColor: null | string) {
      theState.backgroundColor = backgroundColor;
    },
    [SET_TOP_BAR_TEXT](theState: State, topBarText: string) {
      theState.topBarText = topBarText;
    },
    [SET_TOP_BAR_VISIBILITY](theState: State, topBarVisibility: keyof typeof COMPONENT_VISIBILITY) {
      theState.topBarVisibility = topBarVisibility;
    },
    [SET_BOTTOM_NAV_BAR_VISIBILITY](theState: State, visibility: keyof typeof COMPONENT_VISIBILITY) {
      theState.bottomNavBarVisibility = visibility;
    },
  },

  actions: {
    [SET_APP_BACKGROUND_COLOR]({ commit }, backgroundColor: null | string) {
      commit(SET_APP_BACKGROUND_COLOR, backgroundColor);
    },
    [SET_APP_LOCALE](_, locale: keyof typeof SUPPORTED_LOCALES) {
      i18n.locale = locale;
      moment.locale(locale);
      localStorage.setItem("parlaeditor_app_locale", i18n.locale);
    },
    [SET_TOP_BAR_TEXT]({ commit }, topBarText: string) {
      commit(SET_TOP_BAR_TEXT, topBarText);
    },
    [SET_TOP_BAR_VISIBILITY]({ commit }, topBarVisibility: keyof typeof COMPONENT_VISIBILITY) {
      commit(SET_TOP_BAR_VISIBILITY, topBarVisibility);
    },
    [SET_BOTTOM_NAV_BAR_VISIBILITY]({ commit }, bottomNavBarVisibility: keyof typeof COMPONENT_VISIBILITY) {
      commit(SET_BOTTOM_NAV_BAR_VISIBILITY, bottomNavBarVisibility);
    },
  },
};

export default apphModule;
